import { Divider, MaxWidth } from '@advanza/ui'
import ExactExportBlock from 'components/billing/ExactExportBlock'
import Card from 'components/Card'
import LoadBoxWrapper from 'components/ui/LoadBoxWrapper'
import Page from 'components/ui/Page'
import { useInvoiceExport } from 'hooks/billingHooks'
import React from 'react'

const DESCRIPTIONS = {
    relations:
        'Provider accounts (name, address, VAT, bank and contact details). ' +
        'Includes new providers and providers whose details changed since their last export.',
    invoices:
        'Unprocessed invoices of providers that exist in Exact (max 1000 per batch). ' +
        'Export relations first so new providers are known in Exact.',
    mandates:
        'SEPA direct debit mandates (mandate reference, IBAN and signature date) ' +
        'for providers that have not had their mandate exported yet.',
}

const ExactImportPage = ({}) => {
    const {
        isExporting,
        exportInvoices,
        exportRelations,
        exportMandates,
        loadPreviousInvoicesBatch,
        loadPreviousRelationsBatch,
        loadPreviousMandateBatch,
        invoices,
        relations,
        mandates,
    } = useInvoiceExport()
    return (
        <Page>
            <h1>Exact exports</h1>
            <p>
                Generate CSV files for import into Exact (accounting). Clicking an export button
                creates a new batch of everything that is not exported yet; the download link
                appears afterwards. Use &quot;Show previous batches&quot; to re-download an earlier
                export.
            </p>
            <Divider l />
            <MaxWidth maxWidth={500}>
                <LoadBoxWrapper isLoading={isExporting === 'relations'}>
                    <Card header="Relations" icon="group" isLoading={isExporting === 'relations'}>
                        <Divider m />
                        <ExactExportBlock
                            items={relations}
                            type="relations"
                            description={DESCRIPTIONS.relations}
                            downloadUrl="downloadExactRelations"
                            isExporting={isExporting}
                            loadBatchesFunc={loadPreviousRelationsBatch}
                            exportFunc={exportRelations}
                        />
                    </Card>
                </LoadBoxWrapper>
                <Divider m />
                <LoadBoxWrapper isLoading={isExporting === 'invoices'}>
                    <Card
                        header="Invoices"
                        icon="receipt_long"
                        isLoading={isExporting === 'invoices'}>
                        <Divider m />
                        <ExactExportBlock
                            items={invoices}
                            type="invoices"
                            description={DESCRIPTIONS.invoices}
                            downloadUrl="downloadExactInvoices"
                            isExporting={isExporting}
                            loadBatchesFunc={loadPreviousInvoicesBatch}
                            exportFunc={exportInvoices}
                        />
                    </Card>
                </LoadBoxWrapper>
                <Divider m />
                <LoadBoxWrapper isLoading={isExporting === 'mandates'}>
                    <Card
                        header="Mandates"
                        icon="account_balance"
                        isLoading={isExporting === 'mandates'}>
                        <Divider m />
                        <ExactExportBlock
                            items={mandates}
                            type="mandates"
                            description={DESCRIPTIONS.mandates}
                            downloadUrl="downloadExactMandates"
                            isExporting={isExporting}
                            loadBatchesFunc={loadPreviousMandateBatch}
                            exportFunc={exportMandates}
                        />
                    </Card>
                </LoadBoxWrapper>
            </MaxWidth>
        </Page>
    )
}

export default ExactImportPage
